// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".exc-footer__container[data-v-43126ca7]{display:none}@media(min-width:992px){.exc-footer__container[data-v-43126ca7]{display:flex;grid-gap:1rem;gap:1rem}}@media(min-width:992px){.exc-footer__mobile[data-v-43126ca7],.exc-footer__mobile-apps[data-v-43126ca7],.exc-footer__mobile-logo[data-v-43126ca7]{display:none}}.exc-footer .exc-link[data-v-43126ca7]:hover{color:#1c1d20;color:var(--c-main,#1c1d20);cursor:pointer}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
